<script>
import {
  rexText
} from '@/components/views/rexField'

export default {
  name: 'SubscriptionForm',
  components: {
    rexText
  },
  computed: {
    state() {
      return this.$store.getters['subscription/formState']
    }
  },
  methods: {
    send() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('subscription/updateFormState', {
            isLoading: true
          })

          setTimeout(() => {
            this.$store.commit('subscription/updateFormState', {
              isLoading: false,
              isShowed: false
            })
          }, 3000)
        }
      })
    }
  }
}
</script>
<template>
  <div class="subscription-form">
    <div class="subscription-form__container app-content">
      <div v-if="state.isShowed">
        <h3 class="subscription-form__title">
          Подпишитесь на рассылку секретных горячих предложений!
        </h3>
        <p class="subscription-form__subtitle">
          Вы сможете первыми выкупить тур по сниженной цене
        </p>
      </div>
      <div v-else>
        <h3 class="subscription-form__title">
          Мы выслали вам подтверждение на электронную почту
        </h3>
        <p class="subscription-form__subtitle subscription-form__subtitle--no-margin">
          Через пару минут вы получите письмо с подверждением — перейдите по
          ссылке из письма и вы будете первыми узнавать о горячих турах.
        </p>
      </div>
      <div
        v-if="state.isShowed"
        class="subscription-form__form"
      >
        <rex-text
          name="subscriberEmail"
          store-module="subscription"
          getter-name="getField"
          setter-name="setField"
          target="formData.email"
          placeholder="Ваш адрес электронной почты"
          :show-label="false"
          :disabled="state.isLoading"
          :validate="{
            required: true,
            email: true
          }"
        />
        <b-button
          class="rex-button2"
          type="is-primary"
          :loading="state.isLoading"
          @click="send"
        >
          Подписаться
        </b-button>
      </div>
    </div>
  </div>
</template>